var _rect, _rect2, _circle, _circle2, _g, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuHomeAppliance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.33337,
    y: 9.16663,
    width: 23.3333,
    height: 25,
    rx: 3.33333,
    fill: "#C6C6C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33337,
    y: 7.5,
    width: 23.3333,
    height: 25,
    rx: 3.33333,
    fill: "#D1CFCD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21.6666,
    r: 7.5,
    fill: "#ECECEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 16,
    height: 16
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 21.6666,
    r: 7.5,
    fill: "#ECECEC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.75 21.3765C34.1371 21.0003 33.417 20.8114 32.6871 20.8355C31.9572 20.8595 31.2527 21.0953 30.6689 21.5109C30.0519 21.9506 29.3005 22.1884 28.5282 22.1884C27.7559 22.1884 27.0045 21.9506 26.3875 21.5109C25.7704 21.0712 25.019 20.8335 24.2467 20.8335C23.4744 20.8335 22.7231 21.0712 22.106 21.5109C21.4889 21.9506 20.7376 22.1884 19.9653 22.1884C19.193 22.1884 18.4416 21.9506 17.8246 21.5109C17.2075 21.0712 16.4561 20.8335 15.6838 20.8335C14.9115 20.8335 14.1602 21.0712 13.5431 21.5109C12.9259 21.9506 12.1745 22.1884 11.402 22.1884C10.6296 22.1884 9.87817 21.9506 9.261 21.5109C8.64392 21.0712 7.89257 20.8335 7.12027 20.8335C6.34797 20.8335 5.59662 21.0712 4.97954 21.5109C4.36247 21.9506 3.61111 22.1884 2.83881 22.1884C2.06651 22.1884 1.31516 21.9506 0.698083 21.5109C0.0822883 21.0687 -0.670084 20.8306 -1.44297 20.8334C-2.21565 20.8306 -2.96782 21.0687 -3.58337 21.5109V34.1667H34.75V21.3765Z",
    fill: "#FF791C"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 11.6667,
    r: 1.66667,
    fill: "#ECECEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuHomeAppliance);
export default __webpack_public_path__ + "static/media/wikiMenuHomeAppliance.2d3e4990caaa39303185772554afb8d6.svg";
export { ForwardRef as ReactComponent };